// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-25a37705] {\n\theight: calc(100vh - 35px);\n}\n.card-height[data-v-25a37705] {\n\theight: 100%;\n}\n.primary-color[data-v-25a37705] {\n\tcolor: #5d9e82;\n}\n", ""]);
// Exports
module.exports = exports;
